module.exports = __webpack_public_path__ + "img/originalplantillas.4c71b6d9.jpg";